import { render, staticRenderFns } from "./ProductCategorySection.vue?vue&type=template&id=6f10b05a&scoped=true"
import script from "./ProductCategorySection.vue?vue&type=script&lang=ts"
export * from "./ProductCategorySection.vue?vue&type=script&lang=ts"
import style0 from "./ProductCategorySection.vue?vue&type=style&index=0&id=6f10b05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10b05a",
  null
  
)

export default component.exports